import React, { Component, PropTypes } from 'react';
import { withRouter, browserHistory } from 'react-router';
import { connect } from 'react-redux';
import autoBind from 'react-autobind';
import getMuiTheme from 'material-ui/styles/getMuiTheme';
import baseTheme from 'material-ui/styles/baseThemes/lightBaseTheme';
import TextField from 'material-ui/TextField';
import DatePicker from 'material-ui/DatePicker';
import SelectField from 'material-ui/SelectField';
import MenuItem from 'material-ui/MenuItem'; // eslint-disable-line no-unused-vars
import Checkbox from 'material-ui/Checkbox';
import RaisedButton from 'material-ui/RaisedButton';
import { fetchCatalogs, fetchCampaigns, setSalesChannel, clearSalesChannelsErrors } from '../actions';
import { cyan900, cyan500 } from 'material-ui/styles/colors';
import Alert from '../components/home/Alert';
const _ = require('lodash');

const propTypes = {
  dispatch: PropTypes.func,
  isAuthenticated: PropTypes.bool,
  salesChannel: PropTypes.object,
  catalogs: PropTypes.any,
  error: PropTypes.any,
  query: PropTypes.object.isRequired,
  campaigns: PropTypes.object,
};

class SalesChannelNewPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      auth: !props.isAuthenticated,
      alertOpen: false,
      alertMessage: '',
      error: false,
      controls: {
        passcodeDisabled: true,
        requirePasscodeDisabled: true,
        storeDeviceDisabled: true,
        allowPaymentDisabled: true,
      },
      required: {
        //campaignId: null,
        name: null,
        displayName: null,
        subdomain: null,
      },
      salesChannel: {
        name: '',
        displayName: '',
        catalogId: 0,
        disabled: false,
        subdomain: '',
        campaignId: '',
        startDate: '',
        endDate: '',
        debugMode: false,
        giftCard: false,
        pickPack: false,

      },
      saved: false,
    };
    autoBind(this);
  }
  getChildContext() {
    return { muiTheme: getMuiTheme(baseTheme) };
  }
  componentWillMount() {
    if (!this.props.isAuthenticated) {
      browserHistory.goBack();
    }
    this.setRequiredParams();
    this.props.dispatch(fetchCampaigns());
    this.props.dispatch(fetchCatalogs());
  }
  componentWillReceiveProps(nextProps) {
    if (nextProps.error) {
      this.setState({
        alertOpen: true,
        error: true,
        alertMessage: `${nextProps.error.statusCode} ${nextProps.error.error} ${nextProps.error.message}`,
      });
    }
    if (this.state.saved && nextProps.salesChannel && !nextProps.error) {
      this.setState({
        alertOpen: true,
        error: false,
        alertMessage: 'Sales Channel saved successfully!',
      });
    }
    this.setRequiredParams();
  }
  setRequiredParams() {
    const { required, salesChannel } = this.state;
    Object.keys(this.state.required).forEach((paramName) => {
      const param = salesChannel[paramName];
      required[paramName] = (param === null || param.length === 0 || param === 0) ? 'This field is required' : null;
    });
    this.setState({ required });
  }
  handleDatePickerChange(e, date, target) {
    const salesChannel = this.state.salesChannel;
    salesChannel[target] = date;
    this.setState({ salesChannel });
  }

  handleSelectChange(event, index, value, target) {
    const salesChannel = this.state.salesChannel;
    salesChannel[target] = value;
    this.setState({
      salesChannel,
    });
    this.setRequiredParams();
  }
  handleChange(e) {
    const salesChannel = this.state.salesChannel;
    switch (e.target.type) {
      case ('checkbox'):
        salesChannel[e.target.name] = e.target.checked;
        break;
      default:
        salesChannel[e.target.name] = e.target.value;
        break;
    }
    this.setState({
      salesChannel,
    });
    this.setRequiredParams();
  }
  handleSubmit() {
    this.props.dispatch(clearSalesChannelsErrors());
    this.props.dispatch(setSalesChannel(this.state.salesChannel));
    this.setState({ saved: true });
  }
  handleCancel() {
    this.props.dispatch(clearSalesChannelsErrors());
    browserHistory.push('/saleschannels?page=1');
  }
  alertHandleClose() {
    this.setState({
      alertMessage: '',
      alertOpen: false,
    });
    if (!this.state.error) {
      browserHistory.push('/saleschannels?page=1');
    }
  }
  render() {
    // console.log("this.props.catalogs: ", this.props.catalogs)
    // console.log("this.props.campaigns: ", this.props.campaigns)
    const catalogSelect = _.map(this.props.catalogs, c => <MenuItem value={c.id} key={c.id} primaryText={c.name} />);
    const campaignSelect = _.map(this.props.campaigns, c => <MenuItem value={c.id} key={c.id + 9000} primaryText={c.name} />);
    const autoOk = true;
    const authPage = {
      display: 'flex',
      flexWrap: 'wrap',
      justifyContent: 'space-between',
    };
    const styles = {
      floatingLabelStyle: {
        color: cyan900,
      },
      inputStyle: {
        marginRight: '2%',
        width: '250px',
      },
      datePickerStyle: {
        marginRight: '2%',
        width: '250px',
        float: 'left',
      },
      inline: {
        display: 'flex',
        width: '100%',
      },
      inlineBlock: {
        display: 'inline-block',
        width: '50%',
      },
      passcodeUl: {
        display: 'inline-block',
        width: '33%',
        paddingTop: '30px',
      },
      radioButton: {
        marginBottom: 16,
        float: 'left',
        display: 'inline-block',
      },
    };
    return (
      <div className="sales-channels component" style={authPage}>
        <h2>New Sales Channel</h2>
        <Alert
          alertOpen={this.state.alertOpen}
          alertHandleClose={() => this.alertHandleClose()}
          alertMessage={this.state.alertMessage}
        />
        <div className="content">
          <div className="float-right">
            <RaisedButton
              label="Cancel"
              style={{ margin: '20px' }}
              primary
              onClick={this.handleCancel}
            />
            <RaisedButton
              label="Save"
              primary
              onClick={this.handleSubmit}
            />
          </div>
          <br />
          <br />
          <div style={{ marginBottom: '15px' }}>
            <TextField
              floatingLabelText="Name"
              floatingLabelStyle={styles.floatingLabelStyle}
              name="name"
              onChange={this.handleChange}
              style={styles.inputStyle}
              value={this.state.salesChannel.name || ''}
              errorStyle={{ color: cyan500 }}
              errorText={this.state.required.name}
            />
            <TextField
              floatingLabelText="Display Name"
              floatingLabelStyle={styles.floatingLabelStyle}
              name="displayName"
              onChange={this.handleChange}
              style={styles.inputStyle}
              value={this.state.salesChannel.displayName || ''}
              errorStyle={{ color: cyan500 }}
              errorText={this.state.required.displayName}
            />
            <TextField
              floatingLabelText="Subdomain"
              floatingLabelStyle={styles.floatingLabelStyle}
              name="subdomain"
              onChange={this.handleChange}
              style={styles.inputStyle}
              value={this.state.salesChannel.subdomain}
              errorText={this.state.required.subdomain}
              errorStyle={{ color: cyan500 }}
            />
          </div>
          <SelectField
            value={this.state.salesChannel.catalogId}
            onChange={(event, index, value) => this.handleSelectChange(event, index, value, 'catalogId')}
            floatingLabelText="Catalog"
            style={{ verticalAlign: 'bottom', marginRight: '2%', width: '250px' }}
            name="catalogId"
            floatingLabelStyle={styles.floatingLabelStyle}
          >
            <MenuItem value={0} key={0} primaryText="None" />
            {catalogSelect}
          </SelectField>
          <TextField
            floatingLabelText="Activa Campaign Id"
            floatingLabelStyle={styles.floatingLabelStyle}
            name="campaignId"
            style={styles.inputStyle}
            value={this.state.salesChannel.campaignId ? this.state.salesChannel.campaignId : ''}
            onChange={this.handleChange}
            // errorText={this.state.campaignId}
            errorStyle={{ color: cyan500 }}
            // onChange={(event, index, value) => this.handleSelectChange(event, index, value, 'campaignId')}
          />
          <br />
          <div id="datePickerWrapper">
            <DatePicker
              floatingLabelText="Start Date"
              mode="landscape"
              floatingLabelStyle={styles.floatingLabelStyle}
              hintText="Start Date"
              value={this.state.salesChannel.startDate ? new Date(this.state.salesChannel.startDate) : null}
              autoOk={autoOk}
              name="startDate"
              onChange={(e, date) => this.handleDatePickerChange(e, date, 'startDate')}
              style={styles.datePickerStyle}
            />
            <DatePicker
              floatingLabelText="End Date"
              mode="landscape"
              floatingLabelStyle={styles.floatingLabelStyle}
              hintText="End Date"
              value={this.state.salesChannel.endDate ? new Date(this.state.salesChannel.endDate) : null}
              autoOk={autoOk}
              name="endDate"
              onChange={(e, date) => this.handleDatePickerChange(e, date, 'endDate')}
              style={styles.datePickerStyle}
            />
          </div>
          <br />
          <br />
          <div className="optionsDiv">
            <ul style={styles.inline}>
              <li>
                <Checkbox
                  label="Disabled"
                  name="disabled"
                  onCheck={this.handleChange}
                  labelStyle={{ marginLeft: '-12px', width: '100px' }}
                  defaultChecked={this.state.salesChannel.disabled}
                />
              </li>
              <li>
                <Checkbox
                  label="Debug Mode"
                  name="debugMode"
                  onCheck={this.handleChange}
                  labelStyle={{ marginLeft: '-12px', width: '130px' }}
                  defaultChecked={this.state.salesChannel.debugMode}
                />
              </li>
            </ul>
          </div>
        </div>
      </div>
    );
  }
}

SalesChannelNewPage.childContextTypes = {
  muiTheme: PropTypes.object.isRequired,
};

SalesChannelNewPage.propTypes = propTypes;

function mapStateToProps(state, ownProps) {
  return {
    isAuthenticated: state.auth.isAuthenticated,
    salesChannel: state.salesChannels.salesChannel,
    catalogs: state.catalogs.results,
    error: state.salesChannels.error,
    query: ownProps.location.query,
    campaigns: state.campaigns.results,
  };
}

export default withRouter(connect(mapStateToProps)(SalesChannelNewPage));



// WEBPACK FOOTER //
// ./src/containers/SalesChannelNewPage.js